/**
 * Created by Vladislav on 25.09.2024.
 */

Placements.ENTRIES["updateMissionTreeUnit"] = {
    type: Placements.FREE_FOCUS,

    filter: function () {
        return MissionTree.wantsToUpdateUnitStage;
    },

    action: function () {
        MissionTree.processStateChange();
    }
};

Placements.ENTRIES["triggerMap2dCounter"] = {
    type: Placements.FREE_FOCUS_MAIN,
    priority: 0,
    filter: function () {
        return Map2d.currentMap;
    },

    action: function () {
        Map2d.currentMap.counter.trigger();
    }
};